import { render, staticRenderFns } from "./ModalVincularClientes.vue?vue&type=template&id=57adeba4&"
import script from "./ModalVincularClientes.vue?vue&type=script&lang=js&"
export * from "./ModalVincularClientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports